import React from 'react'
import {FormattedMessage} from 'react-intl'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import {ContextConsumer} from '../Context'

const styles = {
  card: {
    width: 400,
    position: 'fixed',
    top: 70,
    right: 5,
    padding: 20,
  },
  title: {
    marginBottom: 16,
    fontSize: '1.2rem',
  },
  cardContent: {
    paddingTop: 0,
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },
  cardItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  textField: {
    width: '100%',
  },
  error: {
    color: 'red',
  },
}

const CustomExitUrl = ({classes}) => {
  return (
    <ContextConsumer>
      {context => {
        return (
          <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
              <div className={classes.cardItem}>
                <TextField
                  id="customExitUrl-input"
                  label={<FormattedMessage id="customExitUrl" />}
                  value={context.customExitUrl}
                  onChange={context.handleChange('customExitUrl')}
                  className={classes.textField}
                  type="text"
                  inputProps={{
                    autoCorrect: 'off',
                    autoCapitalize: 'none',
                  }}
                  margin="normal"
                  error={context.notify}
                  required
                  autoFocus
                />
              </div>
            </CardContent>
          </Card>
        )
      }}
    </ContextConsumer>
  )
}

CustomExitUrl.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {withTheme: true})(CustomExitUrl)



// WEBPACK FOOTER //
// ./src/components/CustomExitUrl.js